export class TypeaheadConfig {
    dropup: boolean;
    placeHolder: string;
    buttonText: string;
    buttonClass: string;
    buttonIconClass: string;
    buttonLoadingIconClass: string;
    displayField: string;
    displayGroupedBy: string;
    noResultErrorMessage: string;
    suppressInlineErrorMessage: boolean;
    noButton: boolean;
    inputLabel: string;
    clearAfterOnSelected: boolean;

    constructor() {
        this.dropup = false;
        this.buttonText = "";
        this.buttonClass = "";
        this.buttonIconClass = "";
        this.buttonLoadingIconClass = "";
        this.noResultErrorMessage = "";
        this.suppressInlineErrorMessage = false;
        this.noButton = false;
        this.inputLabel = null;
    }

    public static CreateDefaultCampaignBrandsLookupTypeaheadConfig(): TypeaheadConfig {
        let config = new TypeaheadConfig();
        config.displayField = "name";
        config.noButton = true;
        config.buttonClass = "btn btn-default";
        config.buttonIconClass = "fa fa-search";
        config.buttonLoadingIconClass = "fa fa-spinner fa-spin";
        config.noResultErrorMessage = "Brands not found.";
        config.suppressInlineErrorMessage = false;
        config.displayGroupedBy = undefined;
        config.placeHolder = "Search for brands...";
        config.buttonText = "";
        config.buttonIconClass = "fa fa-plus";
        config.inputLabel = "";
        config.dropup = false;
        config.clearAfterOnSelected = true;

        return config;
    }

    public static CreateDefaultCampaignThemeCategoriesLookupTypeaheadConfig(): TypeaheadConfig {
        let config = new TypeaheadConfig();
        config.displayField = "name";
        config.noButton = true;
        config.buttonClass = "btn btn-default";
        config.buttonIconClass = "fa fa-search";
        config.buttonLoadingIconClass = "fa fa-spinner fa-spin";
        config.noResultErrorMessage = "Theme category not found.";
        config.suppressInlineErrorMessage = false;
        config.displayGroupedBy = undefined;
        config.placeHolder = "Search for category...";
        config.buttonText = "";
        config.buttonIconClass = "fa fa-plus";
        config.inputLabel = "";
        config.dropup = false;
        config.clearAfterOnSelected = true;

        return config;
    }

    public static CreateDefaultRetailersLookupTypeaheadConfig(): TypeaheadConfig {
        let config = new TypeaheadConfig();
        config.displayField = "retailerName";
        config.noButton = true;
        config.buttonClass = "btn btn-default";
        config.buttonIconClass = "fa fa-search";
        config.buttonLoadingIconClass = "fa fa-spinner fa-spin";
        config.noResultErrorMessage = "Retailers not found.";
        config.suppressInlineErrorMessage = false;
        config.displayGroupedBy = undefined;
        config.placeHolder = "Search for retailer...";
        config.buttonText = "";
        config.buttonIconClass = "fa fa-plus";
        config.inputLabel = "";
        config.dropup = false;
        config.clearAfterOnSelected = false;

        return config;
    }

    public static CreateDefaultStrategicBusinessInitiativesLookupTypeaheadConfig(): TypeaheadConfig {
        let config = new TypeaheadConfig();
        config.displayField = "name";
        config.noButton = true;
        config.buttonClass = "btn btn-default";
        config.buttonIconClass = "fa fa-search";
        config.buttonLoadingIconClass = "fa fa-spinner fa-spin";
        config.noResultErrorMessage = "business driver not found.";
        config.suppressInlineErrorMessage = false;
        config.displayGroupedBy = undefined;
        config.placeHolder = "Search for business driver...";
        config.buttonText = "";
        config.buttonIconClass = "fa fa-plus";
        config.inputLabel = "";
        config.dropup = false;
        config.clearAfterOnSelected = false;

        return config;
    }
    public static CreateDefaultBudgetYearLookupTypeaheadConfig(): TypeaheadConfig {
        let config = new TypeaheadConfig();
        config.displayField = "fiscalYear";
        config.noButton = true;
        config.buttonClass = "btn btn-default";
        config.buttonIconClass = "fa fa-search";
        config.buttonLoadingIconClass = "fa fa-spinner fa-spin";
        config.noResultErrorMessage = "budget year not found.";
        config.suppressInlineErrorMessage = false;
        config.displayGroupedBy = undefined;
        config.placeHolder = "Search for budget year...";
        config.buttonText = "";
        config.buttonIconClass = "fa fa-plus";
        config.inputLabel = "";
        config.dropup = false;
        config.clearAfterOnSelected = false;

        return config;
    }
    public static CreateDefaultDeliveryMethodsLookupTypeaheadConfig(): TypeaheadConfig {
        let config = new TypeaheadConfig();
        config.displayField = "name";
        config.noButton = true;
        config.buttonClass = "btn btn-default";
        config.buttonIconClass = "fa fa-search";
        config.buttonLoadingIconClass = "fa fa-spinner fa-spin";
        config.noResultErrorMessage = "delivery method not found.";
        config.suppressInlineErrorMessage = false;
        config.displayGroupedBy = undefined;
        config.placeHolder = "Search for delivery method...";
        config.buttonText = "";
        config.buttonIconClass = "fa fa-plus";
        config.inputLabel = "";
        config.dropup = false;
        config.clearAfterOnSelected = false;

        return config;
    }

    public static CreateDefaultStatesLookupTypeaheadConfig(): TypeaheadConfig {
        let config = new TypeaheadConfig();
        config.displayField = "name";
        config.noButton = true;
        config.buttonClass = "btn btn-default";
        config.buttonIconClass = "fa fa-search";
        config.buttonLoadingIconClass = "fa fa-spinner fa-spin";
        config.noResultErrorMessage = "state not found.";
        config.suppressInlineErrorMessage = false;
        config.displayGroupedBy = undefined;
        config.placeHolder = "Search for state...";
        config.buttonText = "";
        config.buttonIconClass = "fa fa-plus";
        config.inputLabel = "";
        config.dropup = false;
        config.clearAfterOnSelected = false;

        return config;
    }

    public static CreateDefaultCountriesLookupTypeaheadConfig(): TypeaheadConfig {
        let config = new TypeaheadConfig();
        config.displayField = "name";
        config.noButton = true;
        config.buttonClass = "btn btn-default";
        config.buttonIconClass = "fa fa-search";
        config.buttonLoadingIconClass = "fa fa-spinner fa-spin";
        config.noResultErrorMessage = "country not found.";
        config.suppressInlineErrorMessage = false;
        config.displayGroupedBy = undefined;
        config.placeHolder = "Search for country...";
        config.buttonText = "";
        config.buttonIconClass = "fa fa-plus";
        config.inputLabel = "";
        config.dropup = false;
        config.clearAfterOnSelected = false;

        return config;
    }

    //public static CreateDefaultCampaignBrandsLookupTypeaheadConfig(): TypeaheadConfig {
    //    let config = new TypeaheadConfig();
    //    config.displayField = "name";
    //    config.buttonClass = "btn btn-default";
    //    config.buttonIconClass = "fa fa-search";
    //    config.buttonLoadingIconClass = "fa fa-spinner fa-spin";
    //    config.noResultErrorMessage = "Brands not found.";
    //    config.suppressInlineErrorMessage = false;
    //    config.displayGroupedBy = undefined;
    //    config.placeHolder = "Search for Brands...";
    //    config.buttonText = "";
    //    config.buttonIconClass = "fa fa-plus";
    //    config.inputLabel = "Search Brands";
    //    config.dropup = false;

    //    return config;
    //}

    public minify(noButton: boolean = false): void {
        this.buttonText = "";
        this.inputLabel = "";
        this.suppressInlineErrorMessage = true;
        this.noButton = noButton;
        this.placeHolder = "";
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/typeahead/typeahead-config.model.ts